import styled from "styled-components";

export const ButtonStyled = styled.button<{
	$backgroundColor?: string;
	$color?: string;
}>`
	font-weight: 600;
	padding: 1rem 2rem;
	color: var(${(props) => props.$color || "--color-white-fixed"});
	background-color: var(
		${(props) => props.$backgroundColor || "--color-brand-0"}
	);
	border-radius: 5px;
	box-shadow: 1px 2px 5px var(--color-gray-1);
	transition: all 0.3s ease;

	&:hover {
		filter: brightness(1.3);
		box-shadow: 1px 2px 5px var(--color-gray-0);
	}
`;
